import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { CheckCircle, RadioButtonUnchecked } from "@styled-icons/material";
import styled from "styled-components/macro";

class StyledTodoListItem extends React.Component {
  render() {
    return (
      <TodoListItem onClick={this.props.onClick} clickable={this.props.clickable} complete={this.props.complete}>
        <TodoListItemPrefix clickable={this.props.clickable} complete={this.props.complete}>
          {this.props.complete ? <CheckCircle size="24" /> : <RadioButtonUnchecked size="24" />}
        </TodoListItemPrefix>

        {this.props.children}
      </TodoListItem>
    );
  }
}

export default StyledTodoListItem;

StyledTodoListItem.propTypes = {
  clickable: PropTypes.bool.isRequired,
  complete: PropTypes.bool,
  onClick: PropTypes.func,
};

export const TodoListItem = styled.li`
  display: flex;
  padding: 10px 0;
  font-size: var(--juno-font-size-body-sm);
  border-bottom: 1px solid var(--juno-color-pale-grey);

  color: ${(props) => props.clickable && "var(--juno-color-link)"};
  color: ${(props) => props.clickable === false && props.complete && "var(--juno-color-text-secondary)"};
  color: ${(props) => props.complete && props.clickable && "var(--juno-color-link)"};
`;

export const TodoListItemPrefix = styled.span`
  flex: 0 0 auto;
  text-align: left;
  margin-right: 16px;

  color: inherit;
  color: ${(props) => props.complete && "var(--juno-color-green)"};
  color: ${(props) => !props.clickable && "var(--juno-color-text)"};
  color: ${(props) => props.clickable === false && props.complete && "var(--juno-color-pale-green)"};
`;

export const TodoLink = styled(Link)`
  border-bottom: 1px solid transparent;
  &:hover {
    border-bottom-color: ${(props) => props.clickable && "var(--juno-color-link-hover)"};
  }
`;

export const TodoText = styled.div`
  color: inherit;
  border-bottom: 1px solid transparent;
  &:hover {
    cursor: ${(props) => props.clickable && "pointer"};
    color: ${(props) => props.clickable && "var(--juno-color-link-hover)"};
    border-bottom-color: ${(props) => props.clickable && "var(--juno-color-link-hover)"};
    border-bottom-color: ${(props) => (!props.clickable || props.complete) && "transparent"};
    border-bottom-color: ${(props) => props.complete && props.clickable && "var(--juno-color-link-hover)"};
  }
  /* stylelint-disable selector-type-no-unknown */
  ${TodoLink}:hover & {
    border-bottom-color: transparent;
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const TodoDate = styled.div`
  flex: 0 0 auto;
  margin-left: auto;
  padding-left: 1em;
  font-size: var(--juno-font-size-body-sm);
  color: ${(props) => (props.complete ? "var(--juno-color-grey)" : "var(--juno-color-text)")};
`;

export const TodoTextSecondary = styled.div`
  font-size: 14px;
  color: var(--juno-color-text-secondary);
`;
